// Icon utilities and commonly used icon groups
// This provides easy access to icons from the registry with tree-shaking

import { 
  iconRegistry, 
  type IconName, 
  type LucideIcon,
  getIcon,
  // Social icons (not in main registry to avoid bloat)
  Facebook,
  Twitter,
  Linkedin,
  Instagram
} from '@/lib/icon-registry';

// Export the main icon utilities
export { 
  iconRegistry, 
  getIcon, 
  type IconName, 
  type LucideIcon 
};

// Commonly used icon groups for easy importing
export const actionIcons = {
  Check: getIcon('Check'),
  CheckCircle: getIcon('CheckCircle'),
  CheckCircle2: getIcon('CheckCircle2'),
  X: getIcon('X'),
  Plus: getIcon('Plus'),
  Edit: getIcon('Edit'),
  Trash2: getIcon('Trash2'),
  Upload: getIcon('Upload'),
  Search: getIcon('Search'),
  Settings: getIcon('Settings'),
} as const;

export const communicationIcons = {
  Mail: getIcon('Mail'),
  Phone: getIcon('Phone'),
  MessageSquare: getIcon('MessageSquare'),
  Bell: getIcon('Bell'),
} as const;

// Social media icons (separate for Footer and other social components)
export const socialIcons = {
  Facebook,
  Twitter,
  Linkedin,
  Instagram,
} as const;
